import { render } from "./Icon.vue?vue&type=template&id=f89cc2ca"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
script.render = render

export default script